import { basicAuth } from "../standardAuthPatterns";
import { productVariant } from "../types";
import { exactUrlToRegex } from "../urlPatternConversion";

export const fortifyWebInspect = productVariant({
  identifier: "fortifyWebInspect",
  authLabel: "WebInspect",
  protocol: "http",
  defaultUrlPattern: ({ baseUrl }) =>
    exactUrlToRegex(
      baseUrl || "https://webinspect.example.com:8443/webinspect"
    ),
  auth: basicAuth({
    username: { from: "config", field: "username" },
    password: { from: "secret", field: "password" },
  }),
  steps: [
    {
      title: "Set up Fortify WebInspect",
      items: [
        {
          kind: "markdown",
          content:
            "On the WebInspect host, open **Fortify Monitor > Configure WebInspect API**. Select **Basic** authentication and use **Edit access tokens** to add a username and password to wircserver.keys. Enable HTTPS and bind the server certificate, then enter the service URL below. See [WebInspect API configuration](https://www.microfocus.com/documentation/fortify-webinspect/2220/WI_Help_22.2.0/Content/ASCMonitor_Config_WebInspectAPI.html).",
        },
      ],
    },
    {
      title: "Enter connection details",
      items: [
        {
          kind: "baseUrl",
          label: "API base URL",
          required: true,
          placeholder: "https://webinspect.example.com:8443/webinspect",
          target: {
            kind: "configuration",
            field: "baseUrl",
          },
          helperText:
            "Enter the HTTPS hostname, configured port, and /webinspect path of your WebInspect service.",
        },
        {
          kind: "input",
          label: "WebInspect API username",
          required: true,
          target: {
            kind: "configuration",
            field: "username",
          },
          helperText:
            "A username configured for WebInspect REST API Basic authentication in the `wircserver.keys` file.",
        },
        {
          kind: "input",
          label: "WebInspect API password",
          required: true,
          target: {
            kind: "secrets",
            field: "password",
          },
          helperText:
            "The password paired with the configured WebInspect API username in `wircserver.keys`.",
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ baseUrl }) => ({
      url:
        (baseUrl || "https://webinspect.example.com:8443/webinspect")
          .trim()
          .replace(/\/+$/, "") + "/scanner/settings/",
      ...{ method: "GET" },
    }),
  },
});
